import { initialAction, initialState } from './initial';

type Reducer = (
  state: typeof initialState,
  action: typeof initialAction,
) => typeof initialState;

const reducer: Reducer = (state, action) => {
  const { type, payload } = action ?? {};

  switch (type) {
    case 'UPDATE_PRODUCT_NAME':
    case 'UPDATE_PRODUCT_IDENTIFIER':
    case 'UPDATE_PRODUCT_SLUG':
    case 'UPDATE_PRODUCT_BRAND':
    case 'UPDATE_PRODUCT_MAIN_CATEGORY':
    case 'UPDATE_PRODUCT_BREADCRUMB_CATEGORY':
    case 'UPDATE_PRODUCT_OTHER_CATEGORIES':
    case 'UPDATE_PRODUCT_TAGS':
    case 'UPDATE_PRODUCT_DESCRIPTION':
    case 'UPDATE_PRODUCT_BASE_INFO':
    case 'UPDATE_PRODUCT_TYPE':
    case 'UPDATE_PRODUCT_VARIABLE_ATTRIBUTES':
    case 'UPDATE_SUB_PRODUCTS':
    case 'UPDATE_PRODUCT_BASE_ATTRIBUTES':
    case 'UPDATE_PRODUCT_PICTURES':
    case 'UPDATE_PRODUCT_DOCUMENTS':
    case 'UPDATE_PRODUCT_PACKAGING_INFO':
    case 'UPDATE_PRODUCT_VARIANTS':
    case 'UPDATE_PRODUCT_COMPLEMENTS':
    case 'UPDATE_PRODUCT_SEO':
    case 'UPDATE_PRODUCT_STEP': {
      return {
        ...state,
        ...payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer };
